<template>
  <el-dialog
    :title="model.id ? '编辑配件' : '添加配件'"
    :visible.sync="visible"
    width="800px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
    @open="onOpen"
    :append-to-body="true"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="185px"
      size="small"
      inline
    >
      <el-form-item label="名称">
        <div>{{ model.name }}</div>
      </el-form-item>
      <br />
      <el-form-item label="编号" prop="code">
        <!-- <el-input
          v-model.trim="model.code"
          :disabled="
            model.id > 0 &&
            (model.install_base_id != model.base_id ||
              model.receive_base_id > 0 ||
              model.drill_well_id > 0)
          "
        ></el-input> -->
        <el-input v-model.trim="model.code"></el-input>
      </el-form-item>
      <el-form-item
        label="型号"
        :prop="model.category == 1 ? 'model_number' : ''"
      >
        <el-input
          v-model.trim="model.model_number"
          @blur="getItemInfo"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="param.label"
        v-for="param in model.custom_params"
        :key="param.key"
      >
        <el-input
          v-model="param.value"
          v-if="!param.type || param.type == 1"
        ></el-input>
        <el-date-picker
          style="width: 177px"
          v-model="param.value"
          v-else-if="param.type == 2"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-select v-model="param.value" v-else-if="param.type == 3">
          <el-option
            v-for="(option, index) in param.options.split('、')"
            :key="option + index"
            :label="option"
            :value="option"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="期初使用时间" prop="start_man_hour">
        <el-input
          type="number"
          v-model.number="model.start_man_hour"
        ></el-input>
      </el-form-item>
      <el-form-item label="发往基地" prop="base_id" v-if="model.category == 1">
        <BaseSelect
          v-model="model.base_id"
          :disabled="model.id && model.status != 1"
        ></BaseSelect>
      </el-form-item>
      <el-form-item
        label="入库基地"
        prop="base_id"
        v-if="!model.id && model.category == 2"
      >
        <BaseSelect v-model="model.base_id" :filterBlank="true"></BaseSelect>
      </el-form-item>
      <el-form-item label="组装基地" prop="install_base_id">
        <BaseSelect
          v-model="model.install_base_id"
          :disabled="model.id && model.status != 1"
        ></BaseSelect>
      </el-form-item>
      <!-- <el-form-item label="状态" prop="status">
        <ItemStatusSelect v-model="model.status"></ItemStatusSelect>
      </el-form-item> -->
      <el-form-item label="寿命预测值" prop="age">
        <el-input type="number" v-model.number="model.age"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="model.remark"></el-input>
      </el-form-item>
      <el-form-item
        label="附件"
        class="long"
        prop="attachments"
        v-if="!model.id"
      >
        <AttachmentUpload
          v-if="visible"
          v-model="model.attachments"
        ></AttachmentUpload>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { itemNew, itemUpdate, itemList } from '@/service/getData'
import AttachmentUpload from '@/components/AttachmentUpload'

export default {
  components: {
    AttachmentUpload,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
        this.model.custom_params = []
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        code: [{ required: true, message: '请填写编号', trigger: 'blur' }],
        base_id: [{ required: true, message: '请选择', trigger: 'change' }],
        install_base_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        model_number: [
          { required: true, message: '请填写型号', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await itemUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await itemNew(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getItemInfo() {
      if (!this.model.model_number) {
        return
      }
      let res = await itemList({
        model_number: this.model.model_number,
        item_template_id: this.model.item_template_id,
      })

      if (res.data.list.length > 0) {
        let item = res.data.list[0]
        this.model.custom_params = this.copyCustomParam(
          this.model.custom_params,
          item.custom_params,
        )
        this.model.age = item.age
      }
    },

    onOpen() {
      this.model.attachments = []
    },
  },
}
</script>